import {
  TierIiReportEncampStatus,
  TierIiReportKind,
  TierIiReportOrgStatus,
} from "generated-graphql/graphql";
import { DisableFilterWhen, FilterKey } from "hooks/useOmnisearchDatagrid";

import { FilterGroup } from "../../../../components/Omnisearch/FilterPopover";

export const CHEMICAL_FACILITIES_FILTER_GROUPS: FilterGroup[] = [
  // Column 1: Organization + Location
  {
    name: "🏢 Organization & Facility",
    fields: [
      "tenant",
      "customerFacilityId",
      "facility",
      "facilityTags",
      "partnerTenantName",
      "isDemo",
    ],
  },
  {
    name: "📍 Location",
    fields: ["state", "county"],
  },
  {
    name: "📋 Report Status",
    fields: [
      "reportKind",
      "noReport",
      "organizationStatus",
      "encampStatus",
      "needsRevision",
      "needsRevisionReason",
    ],
  },
  // Column 2: Agencies + Account Team
  {
    name: "🚒 Agencies",
    fields: ["fireDepartment", "lepc", "lepcId", "fireDepartmentId"],
  },
  {
    name: "👥 Account Team",
    fields: ["csmName", "amName", "dataManagerName", "wasteManagerName"],
  },
  // Column 3: Customer (Other Filters will follow)
  {
    name: "🤝 Customer",
    fields: ["pocName"],
  },
];

/** A non-Annual kind inner-joins those reports, so "No Report" would match nothing. */
export const REPORT_KIND_DISABLED_WHEN = {
  field: "noReport",
  value: "true",
  reason: "Not used with No Report",
} satisfies DisableFilterWhen;

/** Filters for search keys the grid has no column for. */
export const CHEMICAL_FACILITIES_ADDITIONAL_FILTERS: FilterKey[] = [
  {
    header: "Facility",
    key: "facility",
    filterKeyType: "facility",
  },
  {
    header: "Organization",
    key: "tenant",
    filterKeyType: "multipleTenant",
  },
  {
    header: "Demo Organizations",
    key: "isDemo",
    filterKeyType: "boolean",
  },
  {
    // Multi-select, matching the workflow activities grid — the query
    // already supports several kinds at once.
    header: "Report Kind",
    key: "reportKind",
    filterKeyType: "enumAutocomplete",
    enumValues: Object.values(TierIiReportKind),
    disableFilterWhen: REPORT_KIND_DISABLED_WHEN,
  },
  {
    // No Annual report for the reporting year.
    header: "No Report",
    key: "noReport",
    filterKeyType: "boolean",
  },
  {
    header: "Organization Status",
    key: "organizationStatus",
    filterKeyType: "enumAutocomplete",
    enumValues: Object.values(TierIiReportOrgStatus),
  },
  {
    header: "Encamp Status",
    key: "encampStatus",
    filterKeyType: "enumAutocomplete",
    enumValues: Object.values(TierIiReportEncampStatus),
  },
  { header: "FD ID", key: "fireDepartmentId" },
  { header: "LEPC ID", key: "lepcId" },
  { header: "CERS ID", key: "cersId" },
  { header: "STEERS ID", key: "steersId" },
];
